<template>
  <div>
    <!-- {{user}} -->
    <!-- <h2>{{ user.selector1 }}</h2> -->
    <!-- <hr> -->
    <div class="field-of-fields">

      <h3 style="">Contact Information</h3>
      <hr style="margin-top: 3px; margin-bottom: -5px;">


      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>First Name</label>
            <p>{{ user.first_name }}</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Last Name</label>
            <p>{{ user.last_name }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Email Address</label>
            <p>{{ user.email }}</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Phone Number</label>
            <p>{{ user.phone }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Workplace</label>
            <p>{{ user.text12 }}</p>
          </div>
        </div>
        <!-- <div class="col-lg-6">
          <div>
            <label>Workplace Phone Number</label>
            <input type="text" class="form-control" v-model="workNum1" placeholder="Please include area code.">
          </div>
        </div> -->
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Spouse/Partner First Name</label>
            <p>{{ user.features[0] }}</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Spouse/Partner Last Name</label>
            <p>{{ user.features[1] }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Spouse/Partner Email Address</label>
            <p>{{ user.features[2] }}</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Spouse/Partner Phone Number</label>
            <p>{{ user.features[3] }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Spouse/Partner Workplace</label>
            <p>{{ user.features[4] }}</p>
          </div>
        </div>
        <!-- <div class="col-lg-6">
          <div>
            <label>Workplace Phone Number</label>
            <input type="text" class="form-control" v-model="workNum2" placeholder="Please include area code.">
          </div>
        </div> -->
      </div>


      <div class="row-lg-4">
        <label>Home Address</label>
        <p>{{ user.address1 }}</p>
        <p>{{ user.address2 }}</p>
      </div>

      <div class="row">
        <div class="col-lg-4">
          <label>City</label>
          <p>{{ user.city }}</p>
        </div>
        <div class="col-lg-4">
          <label>State</label>
          <p>{{ user.provincestate }}</p>
        </div>
        <div class="col-lg-4">
          <div>
            <label>Zip Code</label>
            <p>{{ user.postal_code }}</p>
          </div>
        </div>
      </div>


      <h3 style="" class="mt-5">Service Information</h3>
      <!-- <h5>Now let's talk about the position you're trying to fill - help us understand what you're looking for!</h5> -->
      <hr style="margin-top: 3px; margin-bottom: -5px;">


      <div class="row-lg-4">
        <label>Start Date</label>
        <p>{{ new Date(user.available_date).toDateString() }}</p>
      </div>

      <div class="row-lg-4">
        <label> Select the positions that you are trying to fill</label>
        <p>{{ user.job_types.join(', ') }}</p>
      </div>

      <div class="row-lg-4">
        <label>List the days and hours the nannies should expect to work</label>
        <pre>{{ user.text1 }}</pre>
      </div>

      <br>

      <div>
        <p class="mt-3 mb-2">All of the children that will be taken care of.</p>
        <!-- <p>{{ children }}</p> -->
        <div v-for="(child, index) in children" :key="'Child'+index" class="px-2">
          <h5 style="font-weight: 600; margin-bottom: 0;">{{ child.name }}
          </h5>
          <div class="row" style="margin-top: -10px;">
            <div class="col-lg-6">
              <label v-if="child.birthday">Birthday</label>
              <p v-if="child.birthday">{{ new Date(child.birthday).toDateString() }} (Age: {{ getAge(child.birthday) }})</p>
            </div>

            <div class="col-lg-6">
              <label v-if="child.text3">Gender</label>
              <p>{{ child.text3 }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <label v-if="child.text1">Description</label>
              <pre>{{ child.text1 }}</pre>
            </div>
            <div class="col-lg-6">
              <label v-if="child.text2">School</label>
              <pre>{{ child.text2 }}</pre>
            </div>
          </div>
          <hr>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <label>If you have pets, please list the kinds you have</label>
          <pre>{{ user.text7 }}</pre>
        </div>

        <div class="col-lg-12">
          <label>If you have other domestic help, how often do they come</label>
          <pre>{{ user.text10 }}</pre>
        </div>
      </div>

      <div>
        <label> What light housekeeping duties will your nanny be responsible for?</label>
        <pre>{{ user.text2 }}</pre>
      </div>

      <div>
        <label> How do you handle discipline in your home? How do you want a Nanny to handle discipline?* </label>
        <pre>{{ user.text6 }}</pre>
      </div>

      <div class="row">
        <div class="col">
          <label>Pick which words best describes your family?</label>
          <p>{{ user.multiselect1.join(', ') }}</p>
        </div>

        <div class='col'>
          <label>What are the most important qualities you value in a nanny?</label>
          <p>{{ user.multiselect2.join(', ') }}</p>
        </div>
      </div>

      <div class=row>
        <div class="col">
          <label>The nanny will be...</label>
          <br>
          <p>{{ user.selector4 }}</p>
        </div>

        <div class="col">
          <label>Have you employed a Nanny or Au Pair before?</label>
          <p>{{ user.selector5 }}</p>
        </div>

        <div class="col">
          <label>Will they be required to work regularly scheduled shifts?</label>
          <p>{{ user.selector6 }}</p>
        </div>

        <div class="col">
          <label>Are you open to having a nanny take your children outside of the home for child related activity?</label>
          <p>{{ user.selector7 }}</p>
        </div>
      </div>


      <div>
        <label>What salary range are you offering?</label>
        <p>{{ user.text3 }}</p>
      </div>

      <div>
        <label>What benefits will you be providing?</label>
        <p>{{ user.text4 }}</p>
      </div>

      <div>
        <label>Will your nanny be responsible for running any errands or grocery shopping on the job? If yes, please list. </label>
        <p>{{ user.text8 }}</p>
      </div>

      <label style="margin-bottom: 0px;">Select how important these qualities are to you:*</label>
      <div class="row">
        <div class="col">
          <label>Experience</label>
          <p>{{ user.selector1 }}</p>
        </div>

        <div class="col">
          <label>Education</label>
          <p>{{ user.selector2 }}</p>
        </div>

        <div class="col">
          <label>Personality</label>
          <p>{{ user.selector3 }}</p>
        </div>

      </div>

      <div>
        <label>Please list any skills or abilities you desire in a nanny.</label>
        <pre>{{ user.text5 }}</pre>
      </div>

      <div>
        <label>Is there any additional information about your family/family situation that our team should know before beginning your search?</label>
        <pre>{{ user.text11 }}</pre>
      </div>

      <div>
        <label>Is there anything else that you would like to tell us about your children, family, or the position?</label>
        <pre>{{ user.text12 }}</pre>
      </div>

      <div class="row-lg-4">
        <label>How did you hear about us?</label>
        <p>{{ user.marketing_source }}</p>
      </div>

    </div>

  </div>
</template>

<script>

import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      children: [],
    }
  },
  created() {
    this.getChildren()
  },
  methods: {
    // update() {
    //   axios.patch(`/api/people/${this.user.id}/`, {
    //     address1: '47 Hove St',
    //     city: 'Toronto',
    //     postal_code: 'M3H 4Y8'
    //   })
    //     .catch(error => console.log(error))
    // },
    getChildren() {
      axios.get(`/api/children/?user=${this.user.id}`)
        .then(res => {
          this.children = res.data
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/ApplicationView.vue